import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import axios from "axios";
import "../CSS/GalleryEdit2.css";

const GalleryEdit2=()=>{
    const [galleryData, setGalleryData] = useState([]);

    useEffect(() => {
      fetchGalleryData();
    }, []);
  
    const fetchGalleryData = async () => {
      try {
        const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getGalleryContent1");
        const data = response.data ? Object.values(response.data) : [];
        setGalleryData(data);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    return(
        <div className="GalleryEdit2body" style={{backgroundColor:"black"}}>
        {galleryData.length > 0 && galleryData.map((gallery, index) => (

             <div key={index} className="wrapperedit2">
                <h1 className="text-center">{gallery.title3}</h1>
                <p>{gallery.description3}</p>
                {gallery.subtitles3 && gallery.subtitles3.length > 0 && (
                <div className="rotate-inneredit2">
                    <div className="sideedit2 front" style={{ backgroundImage: `url(${gallery.subtitles3[0]?.subimage})` }}>Front</div>
                    <div className="sideedit2 back"  style={{ backgroundImage: `url(${gallery.subtitles3[1]?.subimage})` }}>Back</div>
                    <div className="sideedit2 right" style={{ backgroundImage: `url(${gallery.subtitles3[2]?.subimage})` }}>Right</div>
                    <div className="sideedit2 left"  style={{ backgroundImage: `url(${gallery.subtitles3[3]?.subimage})` }}>Left</div>
                </div>
                )}
            </div>
        ))}
        </div>
    );
}

export default GalleryEdit2;